"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Span = exports.P = exports.Label = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Code = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _createSemanticTextComponent = require("./createSemanticTextComponent");
var _interfaces = require("./interfaces");
// TODO: use HeadingProps for heading components in 5.0
const H1 = exports.H1 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h1', {
  variant: _interfaces.TextVariant.HeadingXL,
  // Override user agent stylesheet
  margin: 0
});
const H2 = exports.H2 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h2', {
  variant: _interfaces.TextVariant.HeadingLG,
  // Override user agent stylesheet
  margin: 0
});
const H3 = exports.H3 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h3', {
  variant: _interfaces.TextVariant.HeadingMD,
  // Override user agent stylesheet
  margin: 0
});
const H4 = exports.H4 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h4', {
  variant: _interfaces.TextVariant.HeadingSM,
  // Override user agent stylesheet
  margin: 0
});
const H5 = exports.H5 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h5', {
  variant: _interfaces.TextVariant.HeadingXS,
  // Override user agent stylesheet
  margin: 0
});
const H6 = exports.H6 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h6', {
  variant: _interfaces.TextVariant.HeadingXXS,
  // Override user agent stylesheet
  margin: 0
});
const P = exports.P = (0, _createSemanticTextComponent.createSemanticTextComponent)('p', {
  variant: _interfaces.TextVariant.BodyMD,
  // Override user agent stylesheet
  margin: 0
});
const Label = exports.Label = (0, _createSemanticTextComponent.createSemanticTextComponent)('label', {
  color: (0, _utils.token)('color.text.secondary'),
  variant: _interfaces.TextVariant.LabelMD,
  // Override user agent stylesheet
  margin: 0
});

// Span and Token do not have a default color and will appear black by default,
// just like the Text component
const Span = exports.Span = (0, _createSemanticTextComponent.createSemanticTextComponent)('span', {
  display: 'inline',
  // Override user agent stylesheet
  margin: 0
});
const Code = exports.Code = (0, _createSemanticTextComponent.createSemanticTextComponent)('code', {
  display: 'inline',
  backgroundColor: (0, _utils.token)('color.neutral.05')
});